import Lottie from "lottie-react";
import LottieIcon from "./NewBadgeAnimation.json";

const NewBadgeComponent = ({ className }) => {
  return (
    <div>
      <Lottie
        animationData={LottieIcon}
        loop={false}
        autoplay={true}
        className={`${className ?? ""}`}
      />
    </div>
  );
};

export default NewBadgeComponent;
